import { createFileRoute } from '@tanstack/react-router'

import { SectionsAddView } from '@/modules/sections'

export const Route = createFileRoute('/_auth/sections/add')({
  component: SectionsAddView
})
